import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BUTTONS, HEADINGS, LABELS } from "@/utils/constants/appConstants/commonConstants";
import { TAG_TEXT } from "@/utils/constants/messages";
import { useAppDispatch } from "@/state/hooks";
import { addTagThunk } from "@/state/tags/thunks";
import { ButtonLoadingContent, loadingButtonClass } from "@/components/buttons/ButtonLoadingContent";
import { Button } from "@/components/ui/button";

const AddTagModal = (props: { show: boolean; onHide?: () => void }) => {
    const dispatch = useAppDispatch();
    const [tagName, setTagName] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");

    const handleHideModal = () => {
        setTagName("");
        setErrMsg("");
        props.onHide?.();
    };

    const handleAddTag = async () => {
        if (tagName.trim() === "") {
            setErrMsg(TAG_TEXT.VALID_TAG_NAME);
            return;
        }
        setIsLoading(true);
        setErrMsg("");
        try {
            await dispatch(addTagThunk(tagName)).unwrap();
            setIsLoading(false);
            handleHideModal();
        } catch (err: any) {
            setIsLoading(false);
            setErrMsg(err?.message || TAG_TEXT.FAILED_ADD_TAG);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handleAddTag();
        }
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) handleHideModal(); }}>
            <DialogContent className="gs-tag-dialog">
                <div className="gs-tag-dialog__header">
                    <h4 className="gs-tag-dialog__title">{HEADINGS.ADD_TAG}</h4>
                </div>

                <div className="gs-tag-dialog__body">
                    <label className="gs-tag-dialog__label" htmlFor="add-tag-input" id="add-new-tag-label">
                        {LABELS.TAG_NAME}
                    </label>
                    <input
                        id="add-tag-input"
                        type="text"
                        placeholder="Enter tag name"
                        autoFocus
                        value={tagName}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setTagName(e.target.value)}
                        className="gs-tag-dialog__input"
                    />
                    {errMsg ? <p className="gs-tag-dialog__error">{errMsg}</p> : null}
                </div>

                <div className="gs-tag-dialog__footer">
                    <Button
                        type="button"
                        id="add-tag-btn-modal"
                        className={loadingButtonClass(isLoading, "gs-tag-dialog__submit")}
                        onClick={handleAddTag}
                        disabled={isLoading}
                        aria-busy={isLoading || undefined}
                    >
                        <ButtonLoadingContent loading={isLoading} loaderId="add-tag-btn-modal-loader">
                            {BUTTONS.SAVE}
                        </ButtonLoadingContent>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AddTagModal;
